import { httpClient, resolveApiUrl } from '#shared/api'
import graphql from '#shared/api/graphql'
import GetServicePlansByRegionResponseData from '../model/get-service-plans-by-region-response-data'
import GetServiceTemplatesResponseData from '../model/get-service-templates-response-data'
import ServiceTemplate from '../model/service-template'

function transformResponse(data: GetServicePlansByRegionResponseData): GetServiceTemplatesResponseData {
  const serviceTemplates: ServiceTemplate[] = []

  for (const plan of data.data.servicePlanByRegion.nodes) {
    let serviceTemplate = serviceTemplates.find(serviceTemplate => serviceTemplate.id === plan.templateId)

    if (!serviceTemplate) {
      serviceTemplate = {
        ...plan.template,
        plans: [],
      }

      serviceTemplates.push(serviceTemplate)
    }

    serviceTemplate.plans.push(plan)
  }

  return {
    data: {
      serviceTemplates: {
        totalCount: serviceTemplates.length,
        nodes: serviceTemplates,
      },
    },
  }
}

interface GetServiceTemplatesOptions {
  clientId?: string | null
  citySlug: string
}

export default async function getServiceTemplates(options: GetServiceTemplatesOptions) {
  const { clientId, citySlug } = options

  const clientIdFilter = `[null, "${clientId}"]`

  const params = [
    citySlug && `region: ${citySlug}`,
    'first: 50',
    clientId && `where: { clientId: { in: ${clientIdFilter} } }`,
  ].filter(Boolean) as string[]

  const response = await httpClient.post<GetServicePlansByRegionResponseData>(resolveApiUrl('@sd-orders'), {
    json: graphql(`
      query {
        servicePlanByRegion(
          ${params.join(', ')}
        ) {
          totalCount
          nodes {
            id
            templateId
            clientId
            workload
            region
            rules
            isDisabled
            template {
              name
              isApproved
              serviceType
              details {
                explanation
              }
              id
            }
            price {
              amount
              currency
            }
          }
        }
      }
    `),
  })

  const parsedResponse = await response.json()
  const transformedResponse = transformResponse(parsedResponse)

  return transformedResponse.data.serviceTemplates
}
